import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=63af3174"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"
import style0 from "./Adjustments.vue?vue&type=style&index=0&id=63af3174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports